<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Approval-Inbox',
};
</script>

<style>

</style>
